import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'components/ui/Button';
import Icon from 'components/AppIcon';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6 particle-bg">
      <div className="text-center max-w-lg glass-morphism p-8 rounded-2xl cyber-border">
        <div className="flex justify-center mb-6">
          <div className="relative">
            <div className="w-20 h-20 bg-gradient-to-br from-brand-cyan via-brand-purple to-brand-green rounded-2xl flex items-center justify-center cyber-glow-intense">
              <Icon name="AlertTriangle" size={36} color="#ffffff" />
            </div>
            <div className="absolute -top-2 -right-2 w-6 h-6 bg-brand-green rounded-full animate-pulse"></div>
          </div>
        </div>

        <h1 className="font-orbitron font-black text-4xl text-foreground mb-2">SYSTEM ANOMALY</h1>
        <p className="font-mono text-sm text-text-tertiary mb-6">Error Code: NX-404 Quantum Route Not Found</p>
        <p className="text-text-secondary mb-8">
          This corridor doesn’t exist in the current dimension. Redirecting is recommended.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            variant="default"
            className="bg-gradient-to-r from-brand-cyan to-brand-purple cyber-glow-intense"
            icon={<Icon name="ArrowLeft" />}
            iconPosition="left"
            onClick={() => window.history.back()}
          >
            Return to Previous Node
          </Button>

          <Button
            variant="outline"
            className="cyber-border hover:cyber-glow"
            icon={<Icon name="Home" />}
            iconPosition="left"
            onClick={handleGoHome}
          >
            Back to Command Center
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
